// extracted by mini-css-extract-plugin
module.exports = {"zone":"Dropzone_zone__2W8Uh"};